<template>
    <!-- <div class="Questionnaire-group" v-if="!Sended">
        <a href="JavaScript:;" class="btn-close">
            <b-icon icon="x-circle-fill" class="rounded-circle bg-white" variant="success"></b-icon>
        </a> -->
        <!-- <b-button pill variant="outline-success" class="link-btn" @click="openFormUrl"> -->
            <!-- <b-icon icon="file-earmark-check-fill" class="link-icon" title="使用者意見回饋"  @click="openFormUrl"></b-icon> -->
            <span @click="openFormUrl">使用者意見回饋</span>
        <!-- </b-button> -->
    <!-- </div> -->
</template>
<script>

export default{
    data(){
        return{
            Sended:false,
            FormURL:"https://docs.google.com/forms/d/e/1FAIpQLScNTpYlyjzlEUlq8w4t4ybGJDPPO9pV5L1fGnlpfFFsqXSPJQ/viewform?usp=pp_url&entry.253972931=",
            //FormURL:"https://docs.google.com/forms/d/e/1FAIpQLSci3li-GHgG5IpdomINc6IyE7w4QJ6xdu1YCqPem11Z9czeRA/viewform?usp=pp_url&entry.1938356871=",
            apiGetToken: (data) =>
                this.userRequest.post("API/Default/GetToken", data),
        }
    },
    created(){
        let fromSended =  sessionStorage.getItem("GoogleFrom");
        //console.log(fromSended)
        if(fromSended){
            this.Sended = true;
        }
    },
    methods:{
        openFormUrl(){
            let tokenid = sessionStorage.getItem("TokenID")
            
            if(tokenid){
                this.FunctionToken(this.getToken, {});
            }
            else{
                window.open(this.FormURL, "_blank");
            }
        },
        getToken(data){
            this.apiGetToken(data).then((res) =>{
                    let json = res.data.replace('"','').split('§')[0];
                    //console.log("apiGetToken",json)
                    let url = "";
                    url =this.FormURL +json;
                    
                    window.open(url, "_blank")
                })
        }
    }
}

</script>


